/**
 * Application Stats Component
 * Displays statistics for applications
 */

import React from 'react';
import './ApplicationStats.css';

const ApplicationStats = ({ stats }) => {
  const {
    total_applications = 0,
    pending_applications = 0,
    approved_applications = 0,
    rejected_applications = 0,
    applications_by_state = {},
    applications_by_month = {}
  } = stats;

  // Calculate percentages
  const pendingPercentage = total_applications > 0 ? Math.round((pending_applications / total_applications) * 100) : 0;
  const approvedPercentage = total_applications > 0 ? Math.round((approved_applications / total_applications) * 100) : 0;
  const rejectedPercentage = total_applications > 0 ? Math.round((rejected_applications / total_applications) * 100) : 0;

  // Get top states
  const topStates = Object.entries(applications_by_state)
    .sort(([,a], [,b]) => b - a)
    .slice(0, 5);

  return (
    <div className="application-stats">
      <div className="stats-header">
        <h3>Application Statistics</h3>
      </div>
      
      <div className="stats-grid">
        {/* Total Applications */}
        <div className="stat-card total">
          <div className="stat-icon">📋</div>
          <div className="stat-content">
            <div className="stat-value">{total_applications}</div>
            <div className="stat-label">Total Applications</div>
          </div>
        </div>

        {/* Pending Applications */}
        <div className="stat-card pending">
          <div className="stat-icon">⏳</div>
          <div className="stat-content">
            <div className="stat-value">{pending_applications}</div>
            <div className="stat-label">Pending Review</div>
            <div className="stat-percentage">{pendingPercentage}%</div>
          </div>
        </div>

        {/* Approved Applications */}
        <div className="stat-card approved">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <div className="stat-value">{approved_applications}</div>
            <div className="stat-label">Approved</div>
            <div className="stat-percentage">{approvedPercentage}%</div>
          </div>
        </div>

        {/* Rejected Applications */}
        <div className="stat-card rejected">
          <div className="stat-icon">❌</div>
          <div className="stat-content">
            <div className="stat-value">{rejected_applications}</div>
            <div className="stat-label">Rejected</div>
            <div className="stat-percentage">{rejectedPercentage}%</div>
          </div>
        </div>
      </div>

      {/* Additional Stats */}
      <div className="stats-details">
        {/* Top States */}
        {topStates.length > 0 && (
          <div className="stat-section">
            <h4>Applications by State</h4>
            <div className="state-list">
              {topStates.map(([state, count]) => (
                <div key={state} className="state-item">
                  <span className="state-name">{state}</span>
                  <span className="state-count">{count}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Monthly Trend */}
        {Object.keys(applications_by_month).length > 0 && (
          <div className="stat-section">
            <h4>Recent Activity</h4>
            <div className="monthly-trend">
              {Object.entries(applications_by_month)
                .sort(([a], [b]) => new Date(b) - new Date(a))
                .slice(0, 6)
                .map(([month, count]) => (
                  <div key={month} className="month-item">
                    <span className="month-name">
                      {new Date(month).toLocaleDateString('en-US', { 
                        month: 'short', 
                        year: 'numeric' 
                      })}
                    </span>
                    <span className="month-count">{count}</span>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicationStats;
